import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const TEXT = {
  BOTH: 'The new message will also include',
  BCC: 'The new message will also Bcc: ',
  CC: 'The new message will also Cc: ',
};

const P = styled.p`
  margin-bottom: 0;
`;

const Ul = styled.ul`
  list-style-type: disc;
  padding-left: ${spacing.plusHalf};
  & > li {
    list-style-type: disc;
  }
`;

type Props = {
  bccText: string;
  ccText: string;
};

export const ModalCarbonCopyText = ({ bccText, ccText }: Props) => {
  if (!ccText && !bccText) return null;

  if (ccText && bccText)
    return (
      <div>
        <P>{TEXT.BOTH}</P>
        <Ul>
          <li>{`Cc: ${ccText}`}</li>
          <li>{`Bcc: ${bccText}`}</li>
        </Ul>
      </div>
    );

  return (
    <div>
      <p>{ccText ? `${TEXT.CC}${ccText}.` : `${TEXT.BCC}${bccText}.`}</p>
    </div>
  );
};
